import { useToggleState } from '@cian/react-utils';
import { Button, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { FC, useCallback } from 'react';

import { ElectronicTradingWidgetLoadable } from '../ElectronicTradingWidgetLoadable';
import { ElectronicTradingWidgetLoadableFallback } from '../ElectronicTradingWidgetLoadableFallback';

import type { ElectronicTradingWidgetProps } from '@cian/frontend-electronic-trading-widget';

type ElectronicTradingButtonProps = ElectronicTradingWidgetProps & {
  buttonText: string;
  trackShowTradingWidgetModal: VoidFunction;
};

export const ElectronicTradingButton: FC<ElectronicTradingButtonProps> = props => {
  const { buttonText, trackShowTradingWidgetModal, ...widgetProps } = props;
  const { state: isModalVisible, toggle: toggleModalVisibility } = useToggleState(false);

  const handleClick = useCallback(() => {
    toggleModalVisibility();
    trackShowTradingWidgetModal();
  }, [toggleModalVisibility, trackShowTradingWidgetModal]);

  return (
    <>
      <ModalWindow
        fixed
        portal
        content={
          <ElectronicTradingWidgetLoadable fallback={<ElectronicTradingWidgetLoadableFallback />}>
            {(Lib): JSX.Element => <Lib.ElectronicTradingWidget {...widgetProps} />}
          </ElectronicTradingWidgetLoadable>
        }
        open={isModalVisible}
        size="M"
        title="Переходим к электронным торгам"
        width={680}
        onClose={toggleModalVisibility}
      />
      {widgetProps.deviceType === 'phone' ? (
        <Button fullWidth onClick={handleClick}>
          {buttonText}
        </Button>
      ) : (
        <Button size="XS" theme="fill_primary" onClick={handleClick}>
          {buttonText}
        </Button>
      )}
    </>
  );
};
